var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowScan(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 58.41 45.71",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.23 12.02a4 4 0 00-5.65 0l-7.64 7.65V0h-30v19.14l-7.11-7.12a4.002 4.002 0 00-5.66 5.66l28 28 28-28a4 4 0 00.06-5.66z",
    fill: "#e22c87"
  })));
}

export default SvgArrowScan;